import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert,
  CircularProgress,
} from "@mui/material";
import { Cookie as CookieIcon, Link as LinkIcon } from "@mui/icons-material";
import axios from "axios";

const CookieValidationDialog = ({ open, onClose }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleExtensionClick = () => {
    window.open(
      "https://chromewebstore.google.com/detail/upstart13-candidate-sourc/cbeojheckkpfadlgbemgdldiafjogdbi?utm_source=item-share-cb&pli=1",
      "_blank"
    );
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <CookieIcon color="warning" />
          <Typography variant="h6">Cookies Expired</Typography>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Alert severity="warning" sx={{ mb: 3 }}>
          <Typography variant="body2">
            Your LinkedIn cookies have expired. Please add your cookies to sync
            with the server.
          </Typography>
        </Alert>

        <Typography variant="body1" sx={{ mb: 2 }}>
          To continue using the application, you need to:
        </Typography>

        <Box sx={{ mb: 3 }}>
          <Typography variant="body2" sx={{ mb: 1 }}>
            1. Click the button below to access the extension
          </Typography>
          <Typography variant="body2" sx={{ mb: 1 }}>
            2. Install and configure the LinkedIn extension
          </Typography>
          <Typography variant="body2">
            3. Login and sync with server
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Close
        </Button>
        <Button
          onClick={handleExtensionClick}
          variant="contained"
          color="primary"
          startIcon={<LinkIcon />}
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <CircularProgress size={16} sx={{ mr: 1 }} />
              Loading...
            </>
          ) : (
            "Get Extension"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CookieValidationDialog;
